<template>
    <div class="btn-group" role="group" aria-label="tab button group">
      <button v-for="(tab, i) in tabs" :key="i" :class="tab.tabCss" v-show="tab.tabShow" @click="btnChange(tab)">
        {{ tab.tabName }}
      </button>
    </div>
  </template>
  <script>
  
  export default {
      name:'Tab',
      props:{
          tab:{
              type:Array,
              required:true,
          },
          activeBtn:{
              type: Boolean,
              required: true
          }
      },
      computed: {
        
      },
      data(){
          return {
              tabs: []
          }
      },
      mounted() {
        const vTab = this.tab;
        vTab.map(x=>{
            if(!x.tabShow){
                x.tabShow = true
            }
            
            return x;
        })
        this.tabs = vTab;
      },
      methods: {
          btnChange(bt){
              if(this.activeBtn) {
                  this.tabs.map((x, i) => {
                      x.tabCss = i == bt.tabNo ? "btn btn-primary" : "btn btn-outline-primary";
                      if(i == bt.tabNo) {
                          this.$emit('changeTab',bt);
                      }
                      return x;
                  });
              }
         },
         changeEnableTabCss() {
              this.tabs.map((x, i) => {
                  x.tabCss = i == 0 ? "btn btn-primary" : "btn btn-outline-primary"
              });
         },
         changeDisableTabCss(){
              this.tabs.map((x, i) => {
                  x.tabCss = i == 0 ? "btn btn-primary" : "btn btn-nonActive"
              });
         }       
      },
  }
  </script>